import { Subscription, Plan } from '../../types';

// This represents the nested subscription object we expect in the user profile
export interface UserSubscription extends Subscription {
  plan?: Plan;
}

// User types as a proper TypeScript enum
export enum UserType {
  BLOCKED = 'blocked',
  UNSUBSCRIBED = 'unsubscribed',
  BASIC = 'basic',
  PRO = 'pro',
  ENTERPRISE = 'enterprise',
  ADMIN = 'admin',
  SUPPORT = 'support'
}

// User type with user_type property
export interface User {
  uid: string; // This is Firebase UID
  internalUserId: string; // Add internalUserId here
  email?: string | null;
  displayName?: string | null;
  photoURL?: string | null;
  user_type: UserType; // This uses the UserType enum defined above
  subscription_status?: string; // Consider using a SubscriptionStatus enum if you have one globally
  credits?: number;
  paddle_customer_id?: string | null; // If you store this
  is_blocked?: boolean; // If you track this
  has_billing_history?: boolean; // <<<< ADDED HERE
  team_id?: string | null;
  // Add any other fields that are part of your user profile data from the API
  created_at?: string; // Example
  updated_at?: string; // Example
  granted_plan_tier_activation_perks?: string[]; // ADD THIS LINE (or boolean[] or appropriate type)
  team_owner_id?: string | null; // <-- Add this line for Swayashin team/enterprise support
  is_github_linked: boolean;
  subscription?: UserSubscription | null; // To hold the user's active subscription details
}

// Auth context interface
export interface AuthContextType {
  user: User | null; // Ensure this uses the User interface from this file
  isAuthenticated: boolean;
  isLoading: boolean;
  isLoggingIn: boolean; // Add missing isLoggingIn
  error: AuthError | null; // Use the structured error type
  signInWithGoogle: (method?: 'popup' | 'redirect') => Promise<boolean>; // Match implementation return type
  logout: () => Promise<void>;
  getAuthToken: () => Promise<string | null>; // Renamed from getToken
  clearError: () => void; // Add missing clearError
  refreshUser: () => Promise<void>; // <-- ADD THIS LINE
  // User type helpers
  userType: UserType | null;
  isAdmin: boolean;
  isBlocked: boolean;
  hasPermission: (requiredTypes: UserType | UserType[]) => boolean;
}

// Define a structured error type
export interface AuthError {
  type: 'firebase' | 'api' | 'credentials' | 'expired' | 'unknown';
  message: string;
  code?: string; // Optional error code
}

// Constants for localStorage
export const TOKEN_KEY = 'access_token';
export const TOKEN_EXPIRY_KEY = 'token_expiry';
export const USER_DATA_KEY = 'user_data';